<div class="starting-from-price" role="list">
    <finder-aag-list-item [icon]="startingPrice.icon">
        <span *ngIf="startingPrice.priceString" [innerHtml]="startingPrice.priceString | safeHtml"></span>
        <finder-icon-tooltip *ngIf="tooltip"
            class="tooltip"
            [id]="tooltip.id"
            [name]="tooltip.name"
            [size]="tooltip.size"
            [color]="tooltip.color"
            [tooltip]="tooltip.text"
            [position]="tooltip.position">
        </finder-icon-tooltip>
    </finder-aag-list-item>
</div>
